import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'
import {stockCardWidgetTranslations} from '@widgets/stock-card'

import {FEATURE_NAMESPACE} from '../consts'

const storageLevelsTranslationModule: TranslationModule = {
  namespace: FEATURE_NAMESPACE,
  resources: {
    'de-DE': () => import('./de_DE.json'),
    'en-GB': () => import('./en_GB.json'),
    'en-US': () => import('./en_US.json'),
    'es-ES': () => import('./es_ES.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'cs-CZ': () => import('./cs_CZ.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'it-IT': () => import('./it_IT.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'sv-SE': () => import('./sv_SE.json')
  }
}

const externalPackageTranslations = combineTranslationBundles([stockCardWidgetTranslations])

export const storageLevelsFeatureTranslations = combineTranslationBundles([
  externalPackageTranslations,
  storageLevelsTranslationModule
])
